// Wrapped in an IIFE so none of these names touch window. The theme loads
// jQuery 3.7.1 AFTER this file, and a global `var $` was being overwritten by
// it -- every $("id") then returned a jQuery object, so `.hidden = true` set a
// property on nothing and the page silently stopped responding to clicks.
// JSONP replies still land on window[cb], which is written explicitly.
(function(){
var SPW = document.querySelector('.spw[data-endpoint]') || document.querySelector('.spw') || {dataset:{}};
var ENDPOINT = (SPW.dataset.endpoint || "").trim();
var SECRET   = (SPW.dataset.secret || "sparify-warranty-2026").trim();
var RETURNS  = (SPW.dataset.returns || "").trim();
// Brands Sparify actually sells on Amazon. Editable in Customize -> Warranty page,
// so the list never needs a code change. Blank = no restriction.
var AMAZON_BRANDS = (SPW.dataset.amazonBrands || "").split(",")
  .map(function(x){return x.trim().toLowerCase()}).filter(Boolean);
var FALLBACK = [{"brand":"100%","category":"","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"AOOCCI","category":"","months":12,"id_type":"SERIAL","id_label":"Serial number","id_where":"On the unit body and on the box label.","id_required":true,"claim_needs":["photo_serial","video_fault"],"days_min":"30","days_max":"45","exclusions":""},{"brand":"BluArmor","category":"","months":12,"id_type":"SERIAL","id_label":"Serial number","id_where":"On the back of the unit and on the box label.","id_required":true,"claim_needs":["photo_serial","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Cramster / Rynox","category":"","months":6,"id_type":"INVOICE_ONLY","id_label":"Invoice number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"DYNO / Silver Stallion","category":"","months":999,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":"Discolouration and bluing from heat is normal on a stainless exhaust and is not a defect"},{"brand":"EJEAS","category":"","months":6,"id_type":"SERIAL","id_label":"Serial number","id_where":"Under the mounting plate on the unit, and on the box label.","id_required":true,"claim_needs":["photo_serial","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Korda","category":"Gloves & boots","months":6,"id_type":"NONE","id_label":"","id_where":"","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Korda","category":"helmets","months":60,"id_type":"NONE","id_label":"","id_where":"","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":"A helmet that has taken an impact cannot be warranted or reused, whatever it looks like outside - this is a safety rule, not a cost one"},{"brand":"Korda","category":"Jacket","months":24,"id_type":"NONE","id_label":"","id_where":"","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Legundary Customs","category":"","months":6,"id_type":"NONE","id_label":"","id_where":"","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"LGP","category":"Audio and intercom","months":12,"id_type":"SERIAL","id_label":"Serial number","id_where":"On the unit and on the box label.","id_required":true,"claim_needs":["photo_serial","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"LGP","category":"Lighting","months":12,"id_type":"SERIAL","id_label":"Serial number","id_where":"On the driver box or the unit body, and on the box label.","id_required":false,"claim_needs":["photo_product","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"LGP","category":"Luggage - hard","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"LGP","category":"Luggage - soft","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"LGP","category":"Tools and accessories","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Maddog","category":"","months":18,"id_type":"SERIAL","id_label":"Serial number","id_where":"Etched on the light body and on the box label.","id_required":true,"claim_needs":["photo_serial","photo_damage","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"PARANI (by SENA)","category":"","months":12,"id_type":"SERIAL","id_label":"Serial number","id_where":"On the unit under the clamp, and on the box label.","id_required":true,"claim_needs":["photo_serial","video_fault"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Red Rooster","category":"","months":999,"id_type":"PART_NUMBER","id_label":"Part number","id_where":"Stamped on the flange or printed on the box label.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":"Discolouration and bluing from heat is normal on a performance exhaust and is not a defect"},{"brand":"SMK","category":"","months":12,"id_type":"NONE","id_label":"","id_where":"","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":"A helmet that has taken an impact cannot be warranted or reused, whatever it looks like outside - this is a safety rule, not a cost one"},{"brand":"TAANC","category":"Luggage - hard","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On your tax invoice, or your Amazon order ID.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"TAANC","category":"Luggage - soft","months":12,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On your tax invoice, or your Amazon order ID.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"Other brand","category":"","months":null,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On the tax invoice emailed with your order.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""},{"brand":"SPIKI","category":"","months":null,"id_type":"INVOICE_ONLY","id_label":"Invoice or order number","id_where":"On your tax invoice, or your Amazon order ID.","id_required":false,"claim_needs":["photo_product","photo_damage"],"days_min":"7","days_max":"14","exclusions":""}];
var AMAZON_OK = ["TAANC"];
var EVIDENCE_WORDS = {
photo_product:"a photo of the product", photo_serial:"a photo of the serial number on the unit",
photo_damage:"a photo of the damage or fault", video_fault:"a short video showing the fault happening",
invoice:"a photo of your invoice", unboxing_video:"your unboxing video"
};
var RULES=FALLBACK, MODE="", LOOKUP=null, EXPIRED=false;
var $=function(id){return document.getElementById(id)};
function esc(s){return String(s==null?"":s).replace(/[&<>"]/g,function(c){
return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]})}
function loadRules(){
if(!ENDPOINT) return;
var cb="wcb"+Date.now(), done=false;
window[cb]=function(res){
done=true;
if(res&&res.ok&&res.rules&&res.rules.length){
RULES=res.rules.map(function(r){
r.months=(r.warranty_months===null||r.warranty_months===undefined)?null:Number(r.warranty_months);
r.days_min=r.service_days_min; r.days_max=r.service_days_max; return r});
fillBrands();
}
try{delete window[cb]}catch(e){window[cb]=undefined}
};
var sc=document.createElement("script");
sc.src=ENDPOINT+"?action=rules&callback="+cb;
sc.onerror=function(){done=true};
document.body.appendChild(sc);
setTimeout(function(){if(!done){try{delete window[cb]}catch(e){}}},25000);
}
function brands(){var s=[],seen={},amz=(channel()==="amazon"&&AMAZON_BRANDS.length);
RULES.forEach(function(r){
if(amz && AMAZON_BRANDS.indexOf(String(r.brand).toLowerCase())===-1) return;
if(!seen[r.brand]){seen[r.brand]=1;s.push(r.brand)}});return s}
function catsOf(b){return RULES.filter(function(r){return r.brand===b&&r.category}).map(function(r){return r.category})}
function ruleOf(b,c){for(var i=0;i<RULES.length;i++){
if(RULES[i].brand===b&&((RULES[i].category||"")===(c||""))) return RULES[i]}
for(var j=0;j<RULES.length;j++){if(RULES[j].brand===b) return RULES[j]} return null}
function fillBrands(){
var s=$("brand"),keep=s.value;
s.innerHTML='<option value="">Select a brand</option>';
brands().forEach(function(b){var o=document.createElement("option");o.value=b;o.textContent=b;s.appendChild(o)});
if(keep) s.value=keep;
}
function show(el,on){$(el).hidden=!on}
function openFlow(mode){
MODE=mode;
$("home").hidden=true; $("statusflow").hidden=true; $("done").hidden=true; $("flow").hidden=false;
$("crumb-now").textContent = mode==="register"?"Register a product":"Make a claim";
$("fault-set").hidden = mode!=="claim";
$("go").textContent = mode==="register"?"Register this product":"Submit claim";
$("declare-text").textContent = mode==="register"
? "I confirm this product was bought from Sparify and that the details above are correct."
: "I confirm this product was bought from Sparify, that the details above are correct, and that I am claiming on the product those details belong to.";
if($("find-hint")) $("find-hint").textContent = mode==="register"
? "Your order number and the mobile used at checkout. These let us match the registration to your purchase."
: "Your order number and the mobile used at checkout, so we can match this claim to the purchase.";
applyChannel(); window.scrollTo({top:0,behavior:"smooth"});
}
$("door-register").addEventListener("click",function(){openFlow("register")});
$("door-claim").addEventListener("click",function(){openFlow("claim")});
$("door-status").addEventListener("click",function(){
$("home").hidden=true;$("flow").hidden=true;$("done").hidden=true;$("statusflow").hidden=false;
window.scrollTo({top:0,behavior:"smooth"})});
function goHome(){$("flow").hidden=true;$("statusflow").hidden=true;$("done").hidden=true;
$("home").hidden=false;window.scrollTo({top:0,behavior:"smooth"})}
$("back").addEventListener("click",goHome); $("back2").addEventListener("click",goHome);
function channel(){var c=document.querySelector('input[name="channel"]:checked');return c?c.value:""}
function applyChannel(){
var c=channel();
$("gate-other").hidden = c!=="other";
$("main").hidden = (c===""||c==="other");
$("order-sub").textContent = c==="amazon"
? "Your Amazon order ID, which begins with 4 and contains dashes."
: "Begins with SP. On your confirmation email or SMS.";
fillBrands();
if($("brand").value && brands().indexOf($("brand").value)===-1){ $("brand").value=""; }
applyBrand();
}
Array.prototype.forEach.call(document.querySelectorAll('input[name="channel"]'),
function(r){r.addEventListener("change",applyChannel)});
// The Shopify order lookup is retired: the order number and mobile go through to
// the sheet and the escalation email, and the agent verifies there. A button that
// cannot reach Shopify is worse than no button, so it is gone from the markup.
if($("find")) $("find").addEventListener("click",function(){
var ord=$("order").value.trim(), ph=$("phone").value.replace(/\D/g,""), box=$("found");
box.hidden=false;
if(!ord&&ph.length!==10){box.className="panel note";
box.innerHTML="<h3>We need one of the two</h3><p>Your order number, or the 10-digit mobile used at checkout. Either is enough.</p>";return}
if(!ENDPOINT){box.className="panel note";
box.innerHTML="<h3>Lookup is off in this preview</h3><p>On the live page this finds your order and lists its products to choose from. Carry on and fill the product in by hand &mdash; the form works either way.</p>";return}
box.className="panel note"; box.innerHTML="<p>Looking up your order&hellip;</p>";
var cb="wlk"+Date.now(), done=false;
window[cb]=function(res){
done=true; try{delete window[cb]}catch(e){window[cb]=undefined}
if(!res||!res.ok||!res.configured||!res.found||!res.orders.length){
box.className="panel note";
box.innerHTML="<h3>We could not match that</h3><p>It may have been placed with a different number, or as a guest. Carry on and fill the product in by hand &mdash; nothing is blocked, a person will match it to the order.</p>";return}
LOOKUP=res.orders[0];
var h="<h3>Order found</h3><div class='found'><b>"+esc(LOOKUP.order_id)+"</b><span class='m'>placed "+
esc(LOOKUP.placed_on)+(LOOKUP.delivered_on?" &middot; delivered "+esc(LOOKUP.delivered_on):"")+
"</span></div><p>Which product is this about?</p><div class='items'>";
LOOKUP.items.forEach(function(it,i){h+="<label class='item'><input type='radio' name='pickitem' value='"+i+"'><span>"+esc(it.title)+"</span></label>"});
h+="</div>";
box.className="panel ok"; box.innerHTML=h;
if(LOOKUP.delivered_on) $("delivered").value=LOOKUP.delivered_on;
if(LOOKUP.email&&!$("email").value) $("email").value=LOOKUP.email;
if(LOOKUP.order_id) $("order").value=LOOKUP.order_id;
Array.prototype.forEach.call(box.querySelectorAll('input[name="pickitem"]'),
function(r){r.addEventListener("change",pickItem)});
readout();
};
var sc=document.createElement("script");
sc.src=ENDPOINT+"?action=lookup&callback="+cb+"&order="+encodeURIComponent(ord)+"&phone="+encodeURIComponent(ph);
sc.onerror=function(){if(window[cb])window[cb](null)};
document.body.appendChild(sc);
setTimeout(function(){if(!done&&window[cb])window[cb](null)},12000);
});
function pickItem(ev){
var it=LOOKUP.items[Number(ev.target.value)]; if(!it) return;
$("product").value=it.title;
var t=(it.title+" "+(it.vendor||"")).toLowerCase();
var bs=brands();
for(var i=0;i<bs.length;i++){
var first=bs[i].split(/[ \/]/)[0].toLowerCase();
if(first.length>2&&t.indexOf(first)!==-1){$("brand").value=bs[i];break}
}
applyBrand();
}
function monthsLabel(m){
if(m===null||m===undefined) return "Per listing";
if(m>=999) return "Lifetime";
if(m%12===0) return m/12===1?"1 year":(m/12)+" years";
return m+" months";
}
function addMonths(d,m){var x=new Date(d.getTime()),day=x.getDate();
x.setMonth(x.getMonth()+m); if(x.getDate()<day) x.setDate(0); return x}
var FMT={day:"numeric",month:"short",year:"numeric"};
$("brand").addEventListener("change",function(){
var b=$("brand").value, cats=catsOf(b), sel=$("category");
if(cats.length){
sel.innerHTML='<option value="">Select</option>';
cats.forEach(function(c){var o=document.createElement("option");o.value=c;o.textContent=c;sel.appendChild(o)});
$("cat-field").hidden=false;
} else { $("cat-field").hidden=true; sel.innerHTML=''; }
applyBrand();
});
$("category").addEventListener("change",applyBrand);
$("delivered").addEventListener("change",readout);
function current(){ return ruleOf($("brand").value, $("cat-field").hidden?"":$("category").value) }
function applyBrand(){
var b=current(), c=channel();
var needCat = !$("cat-field").hidden && !$("category").value;
var idf=$("id-field");
idf.hidden = needCat || !(b&&b.id_type&&b.id_type!=="NONE");
if(!idf.hidden){
$("id-label").innerHTML=esc(b.id_label||"Identifier")+(b.id_required?' <span class="req">*</span>':'');
$("id-where").textContent=b.id_where||"";
}
var ex=$("excl");
if(b&&b.exclusions&&!needCat){
ex.hidden=false;
ex.innerHTML="<h3>What this brand does not cover</h3><p>"+esc(b.exclusions)+".</p>";
} else ex.hidden=true;
var needs=(b&&b.claim_needs)||[];
var words=needs.map(function(k){return EVIDENCE_WORDS[k]||k}).filter(Boolean);
$("ev-req").hidden=!(MODE==="claim"&&words.length);
$("ev-needs").innerHTML = words.length
? "For this product we need "+esc(words.join(", and "))+".<br><b>Two photos and two videos are required.</b> Upload them to Google Drive, Dropbox or any link-sharing service, set the link so anyone with it can view, and paste that single link below. Do not attach files here."
: "<b>Two photos and two videos are required.</b> Upload them to Google Drive, Dropbox or any link-sharing service, set the link so anyone with it can view, and paste that single link below.";
readout();
}
function readout(){
var b=current(), dv=$("delivered").value, box=$("readout");
var needCat = !$("cat-field").hidden && !$("category").value;
if(!b||needCat){box.hidden=true;$("win-note").hidden=true;EXPIRED=false;$("go").disabled=false;return}
box.hidden=false;
var m=(b.months===undefined)?b.warranty_months:b.months; if(m===undefined) m=null;
$("r-term").textContent=monthsLabel(m);
$("r-days").textContent = (b.days_min&&b.days_max) ? (b.days_min+"\u2013"+b.days_max+" days") : "\u2014";
if(!dv||m===null){$("r-ends").textContent=m===null?"See listing":"Add date";$("win-note").hidden=true;EXPIRED=false;$("go").disabled=false;return}
if(m>=999){$("r-ends").textContent="No end";$("win-note").hidden=true;EXPIRED=false;$("go").disabled=false;return}
var d=new Date(dv+"T00:00:00"); if(isNaN(d.getTime())){$("r-ends").textContent="\u2014";return}
var ends=addMonths(d,m), today=new Date(); today.setHours(0,0,0,0);
var days=Math.round((ends-today)/86400000), age=Math.round((today-d)/86400000);
$("r-ends").textContent=ends.toLocaleDateString("en-IN",FMT)+(days<0?" (expired)":"");
var n=$("win-note");
EXPIRED = (MODE==="claim" && days<0);
if(EXPIRED){
n.hidden=false; n.className="panel stop";
n.innerHTML="<h3>This product is outside its warranty period</h3>"+
"<p>Cover on this product ended on <b>"+esc(ends.toLocaleDateString("en-IN",FMT))+"</b>, which is "+
Math.abs(days)+" day"+(Math.abs(days)===1?"":"s")+" ago, so we are not able to accept a warranty claim on it.</p>"+
"<p><b>If you have entered the wrong delivery date, correct the date above</b> and this message will clear.</p>"+
"<p>If the product arrived faulty or wrong, that is a return rather than a warranty claim"+
(RETURNS?" &mdash; use <a href=\""+RETURNS+"\">Return and Replacement</a>":"")+
". For anything else, email support@sparify.co with your order number and we will look at it.</p>";
$("go").disabled=true; return;
}
$("go").disabled=false; n.className="panel note";
if(MODE==="claim"&&age>=0&&age<=7){
n.hidden=false;
n.innerHTML="<h3>This probably belongs in returns, not warranty</h3><p>It is only "+age+
" day"+(age===1?"":"s")+" since delivery. Inside 7 days a faulty product goes through "+
(RETURNS?("<a href='"+RETURNS+"'>Return and Replacement</a>"):"Return and Replacement")+
", which is quicker and replaces the item outright. Use that unless you have already been told otherwise.</p>";
} else if(days<0){
n.hidden=false;
n.innerHTML="<h3>Outside the warranty period</h3><p>Cover on this one ran to "+
ends.toLocaleDateString("en-IN",FMT)+". You can still submit and we read every claim, but expect the date to count against it.</p>";
} else if(MODE==="register"&&age>30){
n.hidden=false;
n.innerHTML="<h3>Registering late is fine</h3><p>It is "+age+" days since delivery. Registration is open for 30 days, so this will be marked late &mdash; it invalidates nothing, it just means a claim gets one extra check.</p>";
} else n.hidden=true;
}
function bad(id,on){$(id).hidden=!on;return on}
$("form").addEventListener("submit",function(ev){
ev.preventDefault();
if(EXPIRED){ $("win-note").scrollIntoView({behavior:"smooth",block:"center"}); return; }
var b=current(), e=false;
e=bad("e-brand",!$("brand").value)||e;
e=bad("e-category",!$("cat-field").hidden&&!$("category").value)||e;
e=bad("e-product",!$("product").value.trim())||e;
e=bad("e-name",!$("name").value.trim())||e;
e=bad("e-email",!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test($("email").value.trim()))||e;
e=bad("e-phone",!/^[6-9]\d{9}$/.test($("phone").value.replace(/\D/g,"")))||e;
e=bad("e-delivered",!$("delivered").value)||e;
e=bad("e-identifier",!!(b&&b.id_required&&b.id_type!=="NONE")&&!$("identifier").value.trim())||e;
if(MODE==="claim"){
e=bad("e-fault",$("fault").value.trim().length<10)||e;
e=bad("e-evidence",!!(b&&b.claim_needs&&b.claim_needs.length)&&!$("evidence").value.trim())||e;
}
e=bad("e-declare",!$("declare").checked)||e;
if(e) return;
var m=b?((b.months===undefined)?b.warranty_months:b.months):null;
var p={action:MODE,secret:SECRET,submitted_at:new Date().toISOString(),
channel:channel(),brand:$("brand").value,category:$("cat-field").hidden?"":$("category").value,
product:$("product").value.trim(),identifier:$("identifier").value.trim(),
order_id:$("order").value.trim(),
order_verified:!!(LOOKUP&&LOOKUP.order_id&&LOOKUP.order_id.toUpperCase()===$("order").value.trim().replace(/^#/,"").toUpperCase()),
phone:$("phone").value.replace(/\D/g,""),name:$("name").value.trim(),
email:$("email").value.trim(),delivered_on:$("delivered").value,
warranty_months:(m===undefined?null:m),
fault:MODE==="claim"?$("fault").value.trim():"",
evidence:MODE==="claim"?$("evidence").value.trim():""};
if(!ENDPOINT){
finish("Preview - nothing was saved","",
"<p>On the live page this is the row written to the "+(MODE==="register"?"register":"claims tab")+
", and you would get a reference number by email.</p><pre>"+esc(JSON.stringify(p,null,2))+"</pre>");
return;
}
$("go").disabled=true; $("go").textContent="Submitting\u2026";
fetch(ENDPOINT,{method:"POST",mode:"no-cors",
headers:{"Content-Type":"text/plain;charset=utf-8"},body:JSON.stringify(p)}).catch(function(){});
finish(MODE==="register"?"Thank you - your product is registered":"Thank you - your claim is submitted","",
MODE==="register"
? "<p>Your warranty number is on its way to <b>"+esc(p.email)+"</b>. Keep that email: if you ever need to claim, the number means we act on it straight away instead of asking you to prove the purchase.</p>"+
"<p>If it has not arrived within 15 minutes, check spam, then email us quoting your order number.</p>"
: "<p>Your claim number is on its way to <b>"+esc(p.email)+"</b>. Our team reviews it against your order and replies on that same thread.</p>"+
"<p>Please keep the product and its packaging as they are. <b>Do not post anything yet</b> - if the claim is approved we email you the address to send it to.</p>");
});
function finish(title,ref,html){
var m=$("spw-modal");
$("spw-modal-h").textContent=title;
$("spw-modal-body").innerHTML=(ref?("<div class='ref'>"+esc(ref)+"</div>"):"")+html;
m.hidden=false;
document.documentElement.style.overflow="hidden";
$("spw-modal-close").focus();
}
function closeModal(){
$("spw-modal").hidden=true;
document.documentElement.style.overflow="";
goHome();
}
if($("spw-modal-close")) $("spw-modal-close").addEventListener("click",closeModal);
if($("spw-modal")) $("spw-modal").addEventListener("click",function(e){
if(e.target===$("spw-modal")) closeModal()});
document.addEventListener("keydown",function(e){
if(e.key==="Escape"&&$("spw-modal")&&!$("spw-modal").hidden) closeModal()});
var STEPS=["NEW","IN REVIEW","AWAITING CUSTOMER","APPROVED - SEND IT IN","RECEIVED AT WAREHOUSE",
"REPLACEMENT DISPATCHED","REPAIRED AND DISPATCHED"];
$("s-go").addEventListener("click",function(){
var ref=$("s-ref").value.trim(), ph=$("s-phone").value.replace(/\D/g,""), box=$("s-out");
box.hidden=false;
if(!ref||ph.length!==10){box.className="panel note";
box.innerHTML="<h3>We need both</h3><p>Your claim reference and the 10-digit mobile on the claim.</p>";return}
if(!ENDPOINT){box.className="panel note";
box.innerHTML="<h3>Lookup is off in this preview</h3><p>On the live page this shows where your claim has reached, the same ladder you are emailed at each step.</p>";return}
box.className="panel note"; box.innerHTML="<p>Checking&hellip;</p>";
var cb="wst"+Date.now(), done=false;
window[cb]=function(res){
done=true; try{delete window[cb]}catch(e){window[cb]=undefined}
if(!res||!res.ok){box.className="panel note";
box.innerHTML="<h3>We could not check just now</h3><p>Please try again shortly, or email support@sparify.co with your reference.</p>";return}
if(!res.found){box.className="panel note";
box.innerHTML="<h3>No claim matches that</h3><p>Check the reference against the email we sent, and that the mobile is the one on the claim. If both look right, email support@sparify.co and we will find it.</p>";return}
var idx=STEPS.indexOf(String(res.status).toUpperCase());
var h="<h3>"+esc(res.ref)+"</h3><div class='found'><b>"+esc(res.plain)+"</b><span class='m'>"+
esc(res.brand||"")+(res.product?" &middot; "+esc(res.product):"")+
(res.claimed_at?" &middot; claimed "+esc(res.claimed_at):"")+"</span></div>";
if(idx>-1){
h+="<div class='steps'>";
STEPS.forEach(function(st,i){
if(st==="AWAITING CUSTOMER"&&idx!==2) return;
var k=i<idx?"done":(i===idx?"now":"todo");
h+="<div class='stepline "+k+"'><span class='dot'></span><span>"+
esc(st.charAt(0)+st.slice(1).toLowerCase())+"</span></div>";
});
h+="</div>";
}
if(String(res.status).toUpperCase()==="REJECTED"&&res.note)
h+="<p style='margin-top:16px'><b>Reason:</b> "+esc(res.note)+"</p>";
else if(res.note) h+="<p style='margin-top:16px'><b>Note from our team:</b> "+esc(res.note)+"</p>";
if(res.replacement_awb) h+="<p><b>Tracking:</b> "+esc(res.replacement_awb)+"</p>";
else if(res.days_quoted) h+="<p>Expected to take about "+esc(res.days_quoted)+" working days from the point we received the product.</p>";
box.className="panel ok"; box.innerHTML=h;
};
var sc=document.createElement("script");
sc.src=ENDPOINT+"?action=status&callback="+cb+"&ref="+encodeURIComponent(ref)+"&phone="+encodeURIComponent(ph);
sc.onerror=function(){if(window[cb])window[cb](null)};
document.body.appendChild(sc);
setTimeout(function(){if(!done&&window[cb])window[cb](null)},12000);
});
fillBrands(); loadRules();
if(ENDPOINT) $("tag").hidden=true;
})();
